namespace nscs.screen {

    export class Preloader extends Phaser.GameObjects.Container {

        public static readonly ATLAS:string = 'preloader-atlas';

        private bar:Phaser.GameObjects.Image;
        private barMask:Phaser.GameObjects.Graphics;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.add(new Phaser.GameObjects.Image(this.scene, 125, 161, Preloader.ATLAS, 'loaded_mc'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 125, 140, Preloader.ATLAS, 'loadingtxt'+'0000').setOrigin(0, 0));

            let preloader_burger:Phaser.GameObjects.Sprite = new Phaser.GameObjects.Sprite(this.scene, 305, 130, Preloader.ATLAS, 'preloader_burger'+'0000');
            let preloader_burger_playing:string = 'preloader_burger_playing';
            this.scene.anims.create({
                key: preloader_burger_playing,
                frames: this.scene.anims.generateFrameNames(Preloader.ATLAS, {
                    start: 0, end: 69, zeroPad: 4,
                    prefix: 'preloader_burger', suffix: ''
                }),
                frameRate: 24, repeat: -1
            });
            preloader_burger.anims.play(preloader_burger_playing);
            this.add(preloader_burger);

            this.bar = new Phaser.GameObjects.Image(this.scene, 125, 161, Preloader.ATLAS, 'preloader_bar'+'0000');
            this.bar.setOrigin(0, 0);
            this.add(this.bar);

            this.barMask = new Phaser.GameObjects.Graphics(this.scene);
            this.barMask.setPosition(this.bar.x, this.bar.y);
            this.barMask.fillStyle(0xFFFFFF, 1);
            this.barMask.fillRect(0, 0, this.bar.width, this.bar.height);

            this.bar.setMask(this.barMask.createGeometryMask());
            sendEvent(petaGA_GameCategory_Game, 'Load', 'Super Chick Sisters - Load');
                    
        }

        public updateProgress(progress:number):void {
            this.barMask.scaleX = progress;
        }
    }
}